"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(e){return function(t){e.forEach((function(e){"function"==typeof e?e(t):null!=e&&(e.current=t)}))}};
//# sourceMappingURL=react-merge-refs.cjs.production.min.js.map
